import styled from 'styled-components';

const AppWorkspace = styled.main`
  flex-grow: 1;
  flex-basis: 100%;
  width: calc(100% - ${props => props.theme.drawerWidth}px);
  position: relative;
`;

export default AppWorkspace;
